import { Redirect as ReactRedirect } from 'react-router-dom'

export const Redirect = ({ to, ...rest }) => {
  // location.search, not toString().split('?')[1] — the latter drags the
  // current URL's #hash into the last merged param value (`a=1%23h`).
  const loc = window.location.search

  to = redirectWithParams(to, loc)

  return (
    <>
      <ReactRedirect to={to} {...rest} />
    </>
  )
}

export function redirectWithParams(to, windowLoc) {
  const windowLocParams = new URLSearchParams(windowLoc);
  let pathname, params, state, hash;

  if (typeof to === 'string') {
    // indexOf, not split('#') destructuring — a hash may itself contain '#'
    const hashIndex = to.indexOf('#');
    const beforeHash = hashIndex === -1 ? to : to.slice(0, hashIndex);
    const hashPart = hashIndex === -1 ? '' : to.slice(hashIndex + 1);
    hash = hashPart ? '#' + hashPart : undefined;
    pathname = beforeHash.split('?')[0];
    params = new URLSearchParams(beforeHash.split('?')[1]);
  } else if (typeof to === 'object') {
    pathname = to.pathname;
    state = to.state;
    hash = to.hash;
    // `search` may be present-but-undefined on a caller-built location object
    params = new URLSearchParams(to.search || '');
  } else {
    throw new Error('Unexpected to argument type, should be string or object');
  }

  // Iterate over all parameters in windowLocParams and set them in params
  for (const [key, value] of windowLocParams.entries()) {
    params.set(key, value);
  }

  const search = params.toString().length > 0 ? '?' + params.toString() : '';

  // Return a location object so react-router preserves `state` (and `hash`)
  // across the redirect — a string `to` silently drops them (see #1707).
  return {
    pathname: pathname || '/',
    search,
    ...(hash ? { hash } : {}),
    ...(state !== undefined ? { state } : {}),
  };
}
